import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

interface NewSourceWizardState {
  step: 1 | 2 | 3;
}

const initialState: NewSourceWizardState = {
  step: 1,
};

const newSourceWizardSlice = createSlice({
  name: 'newSourceWizard',
  initialState,
  reducers: {
    setWizardStep: (state, action: PayloadAction<1 | 2 | 3>) => {
      state.step = action.payload;
    },
    resetWizard: (state) => {
      state.step = 1;
    },
  },
});

export const { setWizardStep, resetWizard } = newSourceWizardSlice.actions;

type NewSourceWizardRootState = { newSourceWizard: NewSourceWizardState };

export const selectWizardStep = (state: NewSourceWizardRootState) => state.newSourceWizard.step;

export default newSourceWizardSlice.reducer;
